import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import LogoutButton from './LogoutButton'

class SidebarDesktopBase extends Component {

    render() {
        let activeClass = "group flex items-center px-2 py-2 text-sm leading-5 font-medium bg-gray-300 text-gray-700 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150"
        let inactiveClass= "group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition ease-in-out duration-150";

        return (
            <div className="hidden md:flex md:flex-shrink-0">
                <div className="flex flex-col w-64 border-r border-gray-200 bg-white">
                    <div className="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                        <div className="flex items-center flex-shrink-0 px-4 font-bold">
                            <img className="h-8 w-auto mr-4" src="images/LogoSmallText.png" alt={process.env.REACT_APP_NAME} /> {process.env.REACT_APP_NAME}
                        </div>
                        {/* Sidebar component, swap this element with another sidebar if you like */}
                        <nav className="mt-5 flex-1 px-2 bg-white">
                            <Link to="/dashboard" className={(this.props.location.pathname === '/dashboard') ? activeClass : inactiveClass}>
                                <svg className="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                Dashboard
                            </Link>
                            <Link to="/picker" className={(this.props.location.pathname === '/picker') ? 'mt-1 '+activeClass : 'mt-1 '+inactiveClass}>
                                <svg className="mr-3 h-6 w-6 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                </svg>
                                Studio
                            </Link>
                            <Link to="/gallery" className={(this.props.location.pathname === '/gallery') ? 'mt-1 '+activeClass : 'mt-1 '+inactiveClass}>
                                <svg className="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                                </svg>
                                Gallery
                            </Link>
                            <Link to="/admin" className={(this.props.location.pathname === '/admin') ? 'mt-1 '+activeClass : 'mt-1 '+inactiveClass}>
                                <svg className="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                                </svg>
                                Admin
                            </Link>
                        </nav>
                    </div>
                    <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
                        <div className="flex-shrink-0 w-full group block">
                            <div className="flex items-center">
                                <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                                    <span className="font-medium leading-none text-white">TS</span>
                                </span>
                                {this.props.authUser ? (
                                    <div className="flex-grow ml-3">
                                        <Link to="/profile" className="text-base leading-6 font-medium text-gray-700 group-hover:text-gray-900">
                                                { this.props.authUser.email.length > 15 ? (
                                                        <span>{this.props.authUser.email.substring(0,15) + '...'}</span>
                                                    ) : (
                                                        <span>{this.props.authUser.email}</span>
                                                    )
                                                }
                                        </Link>
                                        <div className="w-full flex justify-between">
                                            <Link to="/profile" className="text-sm leading-5 font-medium text-gray-500 group-hover:text-gray-700 group-focus:underline transition ease-in-out duration-150">
                                                View profile
                                            </Link>
                                            <LogoutButton />
                                        </div>
                                    </div>
                                ) : (
                                        <div className="ml-3">
                                            <Link to="/login" className="text-sm leading-5 font-medium text-gray-500 group-hover:text-gray-700 group-focus:underline transition ease-in-out duration-150">Login</Link>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const SidebarDesktop = withRouter(SidebarDesktopBase)

export default SidebarDesktop;
